import { BACKEND_URL } from '../../../../constants/api'
import { API_PATH } from './AuthForm-constants'
import { CredencialsType } from './AuthForm-types'

export const loginCall = async (credencials: CredencialsType) => {
  const formData = new FormData()
  try {
    formData.append('username', credencials.login)
    formData.append('password', credencials.password)
    const response = await fetch(`${BACKEND_URL}/${API_PATH}`, {
      method: 'POST',
	  mode: 'cors',
      body: formData
    })
    if (!response.ok) {
      const responseObj = await response.json()
      const error = responseObj?.detail[0]?.msg
      throw new Error(error)
    }
    return response.json()
  } catch (error: any) {
    return await Promise.reject(
      error?.message ?? 'Проблема соединения с сервером'
    )
  }
}
